import { Text, Title, Burger, Drawer, Menu, Image } from "@mantine/core";
import { useState, useEffect } from "react";
import React from "react";
import { useLocation, useNavigate, useMatch } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";

function Header() {
  const [opened, setOpened] = useState(false);
  const [name, setName] = useState("");
  const title = opened ? "Close menu" : "Open menu";
  const navigate = useNavigate();
  const path = useLocation().pathname;
  const userId = localStorage.getItem("userId");

  const match = useMatch("/cards/:id/edit");
  const shouldRender = match !== null;

  useEffect(() => {
    axios
      .get(`${API_URL}/users/${userId}`)
      .then((response) => {
        setName(response.data.data.name.split(" ")[0]);
      });
  }, []);

  const handleLogout = () => {
    navigate("/login");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
  };
  return (
    <>
      <Burger
        color="white"
        opened={opened}
        onClick={() => setOpened((o) => !o)}
        title={title}
      />
      <Drawer
        position="left"
        onClose={() => setOpened(false)}
        padding="md"
        size="md"
        opened={opened}
      >
        <Menu>
          <Menu.Item>
            <Image
              style={{ borderRadius: "50%" }}
              width={100}
              height={100}
              src={
                "default.jpg"
              }
            />
          </Menu.Item>
          <Menu.Item
            style={{ fontSize: "2rem" }}
            onClick={() => navigate("/profile")}
          >{`${name}`}</Menu.Item>
          <Menu.Item onClick={() => navigate("/")} style={{ fontSize: "2rem" }}>
            Dashboard
          </Menu.Item>
          <Menu.Item
            style={{ fontSize: "2rem" }}
            onClick={() => navigate("/create")}
          >
            Add Deck
          </Menu.Item>
          <Menu.Item
            color="red"
            onClick={() => handleLogout()}
            style={{ fontSize: "2rem", marginTop: "20rem" }}
          >
            Logout
          </Menu.Item>
        </Menu>
      </Drawer>
      {path === "/" && (
        <div>
          <Title align="center" style={{ color: "white" }}>
            {`Welcome, ${name}!`}
          </Title>
          <Text align="center" style={{ color: "white" }}>
            Let's get back to studying
          </Text>
        </div>
      )}
      {shouldRender && (
        <Title align="center" style={{ color: "white" }}>
          Edit Deck
        </Title>
      )}
      {path === "/create" && (
        <Title align="center" style={{ color: "white" }}>
          Create Deck
        </Title>
      )}
      {path === "/profile" && (
        <Title align="center" style={{ color: "white" }}>
          {`Hello, ${name}!`}
        </Title>
      )}
    </>
  );
}

export default Header;
